<template>
  <ScreenAdapter>
    <div id="main">
      <Header />
      <div class="platform-cover" :style="`background:url(${cover}) no-repeat center/cover`"></div>
      <Nav />
      <div class="eol-main-container">
        <!-- 理论强党 -->
        <div class="theory-content">
          <div class="content-header" ref="107"></div>
          <div class="content-box" v-if="theoryData&&theoryData.length>0">
            <div class="show-cover" @click="jumpDetail(theoryData[swiperActive])" :style="`background:url(${theoryData[swiperActive].photo}) no-repeat center/cover;`"></div>
            <div class="swiper">
              <swiper :options="swiperOption">
                <swiper-slide v-for="item,index in theoryData" :key="index" :data-index="index">
                  <div class="cover" :data-index="index" :class="[swiperActive == index ? 'active':'']" :style="`background:url(${item.photo}) no-repeat center/cover;`"></div>
                </swiper-slide>
              </swiper>
              <div class="t swiper-button-next">
                <div class="arrow"></div>
              </div>
              <div class="t swiper-button-prev">
                <div class="arrow"></div>
              </div>
            </div>
          </div>
        </div>
        <!-- 党史教育 -->
        <div class="history-content">
          <div class="content-header" ref="108"></div>
          <div class="content-box" v-if="historyData&&historyData.length>0">
            <div class="swiper">
              <swiper :options="swiperOption2">
                <swiper-slide v-for="item,index in historyData" :key="index">
                  <div class="cover" :class="[swiperActive == index ? 'active':'']" :style="`background:url(${item.photo}) no-repeat center/cover;`" @click="jumpDetail(item)"></div>
                </swiper-slide>
              </swiper>
              <div class="b swiper-pagination" slot="pagination"></div>
              <div class="b swiper-button-next">
              </div>
              <div class="b swiper-button-prev">
              </div>
            </div>
          </div>

          <a target="_blank" :href="course_cover_info.url" class="course-banner" :style="`background:url(${course_cover_info.cover}) no-repeat center/cover`"></a>

        </div>

        <!-- 党员先锋 -->
        <div class="pioneer-content">
          <div class="content-header" ref="109"></div>
          <div class="content-box" v-if="pioneerData&&pioneerData.length>0">
            <div class="cover-item" v-for="item,index in pioneerData" :key="index" @click="jumpDetail(item)">
              <div class="thumb-image" :style="`background:url(${item.photo}) no-repeat center/cover;`">

              </div>
            </div>
          </div>
        </div>
        <!-- 百年党史 -->
        <div class="century-content">
          <div class="content-header" ref="118"></div>
          <div class="content-box" v-if="centuryData&&centuryData.length">
            <div class="big-cover" :style="`background:url(${centuryData[0].photo}) no-repeat center/cover;`" @click="jumpDetail(centuryData[0])"></div>
            <div class="sub-cover">
              <div class="cover-item" v-for="item,index in centuryData.slice(1)" :key="index" @click="jumpDetail(item)" :style="`background:url(${item.photo}) no-repeat center/cover;`"></div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </ScreenAdapter>

</template>

<script>
import Header from "@/components/Hzvtc/Header.vue"
import Nav from "@/components/Hzvtc/Nav.vue"
import Footer from "@/components/Hzvtc/Footer.vue"
import services from '../../../config/services'
import ScreenAdapter from "../../../components/ScreenAdapter.vue"

export default {
  data () {
    let that = this
    return {
      cover: require("../../../assets/hzvtc/cover/culture.png"),
      course_cover_info: {
        cover: require("../../../assets/hzvtc/cover/banner-edu.png"), // 党史教育VR系列资源
        url: `${services.XUEXI_HOST}/center/100028/hzvtc/detail?id=339&key=culture`
      },
      swiperActive: 0,
      school_code: localStorage.getItem("schoolCode"),
      swiperOption: {
        autoplay: {
          delay: 8000,
          disableOnInteraction: false
        },
        // loop: true,
        dynamicBullets: true,
        slidesPerView: 3,
        spaceBetween: 7,
        direction: 'vertical',//设置竖向轮播
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          slideChangeTransitionEnd: function () {
            that.swiperActive = this.realIndex
          },
          click: (e) => {
            that.swiperActive = e.target.getAttribute("data-index")
            console.log(that.swiperActive);
          }
        },
      },
      swiperOption2: {
        autoplay: {
          delay: 15000,
          disableOnInteraction: false
        },
        dynamicBullets: true,
        slidesPerView: 3,
        slidesPerGroup: 3,

        spaceBetween: 41,
        pagination: {
          el: ".b.swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".b.swiper-button-next",
          prevEl: ".b.swiper-button-prev",
        },
        // loop: true,
      },
      theoryData: [], // 理论强党数据
      historyData: [], // 党史教育数据
      pioneerData: [], // 党员先锋数据
      centuryData: [], // 百年党史在浙江数据
    }
  },
  components: {
    Header,
    Nav,
    Footer,
    ScreenAdapter
  },
  mounted () {
    this.getListData()
  },
  methods: {
    // currentActive (index) {
    //   this.swiperActive = index
    // },
    jumpPosition () {
      let that = this
      let position = that.$route.query.id
      if (position) {
        that.$nextTick(() => {
          let topVal = this.$refs[position].getBoundingClientRect().top
          let element = document.getElementsByClassName("outContainer")[0]
          element.scrollTop = topVal - 100
        })
      }
    },
    async getListData () {
      // 理论强党
      await services.getCourseList({ page: 1, size: 100, category_id: "107", school_code: this.school_code }).then(res => {
        this.theoryData = res.data.items
      })

      // 党史教育
      await services.getCourseList({ page: 1, size: 100, category_id: "108", school_code: this.school_code }).then(res => {
        this.historyData = res.data.items
      })

      // 党员先锋
      await services.getCourseList({ page: 1, size: 2, category_id: "109", school_code: this.school_code }).then(res => {
        this.pioneerData = res.data.items
      })

      // 百年党史在浙江
      await services.getCourseList({ page: 1, size: 3, category_id: "118", school_code: this.school_code }).then(res => {
        this.centuryData = res.data.items
      })
      // 锚点定位
      await this.jumpPosition()

    },
    jumpDetail (item) {
      // window.open(`/center/${this.school_code}/class/${item.id}`, "_blank")
      window.open(`/center/${this.school_code}/hzvtc/detail?id=${item.id}&key=culture`, "_blank")
    },
  },
}
</script>

<style lang="less" scoped>
#main {
  background: #fff;
}
.platform-cover {
  background: rgb(204, 62, 62);
  width: 100%;
  height: 510px;
}

.eol-main-container {
  width: 1200px;
  margin: 0 auto;
  padding: 34px 0 0;
  .content-header {
    width: 100%;
    height: 42px;
    position: relative;
    z-index: 10;
  }
  .content-box {
    position: relative;
    z-index: 1;
  }
  .theory-content {
    padding: 76px 18px 54px;
    background: url('../../../assets/hzvtc/list/top-bg.png') no-repeat
      center/cover;
    height: 715px;
    position: relative;
    &::before {
      content: '';
      display: inline-block;
      width: 1920px;
      height: 1022px;
      background: url('../../../assets/hzvtc/list/center-bg.png') no-repeat
        center/cover;
      position: absolute;
      top: 240px;
      left: 50%;
      transform: translateX(-50%);
    }
    .content-header {
      background: url('../../../assets/hzvtc/list/header-llqd.png') no-repeat
        center/cover;
      margin-bottom: 33px;
    }
    .content-box {
      display: flex;
      justify-content: space-between;
      overflow: hidden;
      .show-cover {
        flex-shrink: 0;
        width: 908px;
        height: 510px;
        transition: all 0.3s;
        cursor: pointer;
      }
      .swiper {
        width: 263px;
        height: 510px;
        overflow: hidden;
        padding: 37px 0 37px 0;
        position: relative;
        .swiper-slide {
          cursor: pointer;
          margin-left: 11px;
          .cover {
            width: 100%;
            height: 100%;
            position: relative;
            border: 1px solid transparent;
            transition: all 0.3s;
            &.active {
              border: 1px solid #ad1c28;
              box-shadow: 0px 0px 10px 0px rgba(77, 77, 77, 0.5);
            }
            &.active::before {
              content: '';
              display: inline-block;
              width: 12px;
              height: 141px;
              background: #b61e2a;
              position: absolute;
              top: 50%;
              left: -12px;
              transform: translateY(-50%);
            }
          }
        }
        ::v-deep .swiper-container,
        ::v-deep .swiper-container-vertical > .swiper-wrapper {
          width: 100% !important;
          height: 100% !important;
          position: unset !important;
        }
        ::v-deep .swiper-button-prev,
        ::v-deep .swiper-button-next {
          width: 251px;
          height: 25px;
          background: #d5ae7a;
          border: 1px solid #e3dfde;
          position: absolute;
          left: 12px;
          cursor: pointer;
          .arrow {
            width: 16px;
            height: 9px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
        ::v-deep .swiper-button-prev {
          top: 0;
          .arrow {
            background: url('../../../assets/hzvtc/list/arror-up.png') no-repeat
              center/cover;
          }
        }
        ::v-deep .swiper-button-next {
          bottom: 0;
          .arrow {
            background: url('../../../assets/hzvtc/list/arrow-down.png')
              no-repeat center/cover;
          }
        }
        ::v-deep .swiper-button-disabled {
          cursor: not-allowed;
          opacity: 0.7;
        }
      }
    }
  }
  .history-content {
    margin: 43px 0 72px;
    .content-header {
      background: url('../../../assets/hzvtc/list/header-dsjy.png') no-repeat
        center/cover;
      margin-bottom: 35px;
    }
    .content-box {
      .swiper {
        position: relative;
        .swiper-slide {
          width: 372px;
          height: 248px;
          background: #ffffff;
          border: 1px solid #e8d9c5;
          padding: 20px 0;
        }
        .cover {
          width: calc(100% + 2px);
          height: 100%;
          cursor: pointer;
        }
        ::v-deep .swiper-pagination {
          margin-top: 24px;
          display: flex;
          justify-content: center;
        }
        ::v-deep .swiper-pagination-bullet {
          width: 10px;
          height: 10px;
          background: #cdb29f;
          border-radius: 50%;
          display: block;
          cursor: pointer;
          &:not(:last-child) {
            margin-right: 15px;
          }
        }
        ::v-deep .swiper-pagination-bullet.swiper-pagination-bullet-active {
          background: #dd3639;
        }
        ::v-deep .swiper-button-next,
        ::v-deep .swiper-button-prev {
          width: 17px;
          height: 32px;
          cursor: pointer;
          display: block;
        }
        ::v-deep .swiper-wrapper {
          position: unset !important;
        }
        ::v-deep .swiper-button-prev {
          background: url('../../../assets/hzvtc/list/swiper-prev.png')
            no-repeat center/cover;
          position: absolute;
          top: 41%;
          left: -24px;
        }

        ::v-deep .swiper-button-next {
          background: url('../../../assets/hzvtc/list/swiper-next.png')
            no-repeat center/cover;
          position: absolute;
          top: 41%;
          right: -24px;
        }
      }
    }
  }
  .pioneer-content {
    margin-bottom: 40px;
    position: relative;
    &::before {
      content: '';
      display: inline-block;
      position: absolute;
      width: 1920px;
      background: url('../../../assets/hzvtc/list/footer-bg.png') no-repeat
        center/cover;
      height: 1340px;
      top: -38px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 1;
    }
    .content-header {
      background: url('../../../assets/hzvtc/list/header-dyxf.png') no-repeat
        center/cover;
      margin-bottom: 33px;
    }
    .content-box {
      display: flex;
      justify-content: space-between;
      .cover-item {
        width: 580px;
        height: 387px;
        background: #b61e2a;
        border: 1px solid #e8d9c5;
        padding: 30px 0;
        cursor: pointer;
        .thumb-image {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .century-content {
    .content-header {
      background: url('../../../assets/hzvtc/list/header-bndszzj.png') no-repeat
        center/cover;
      margin-bottom: 32px;
    }
    .content-box {
      display: flex;
      justify-content: space-between;
      cursor: pointer;
      .big-cover {
        width: 785px;
        height: 442px;
      }
      .sub-cover {
        flex: 1;
        margin-left: 43px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .cover-item {
          width: 100%;
          height: 208px;
          cursor: pointer;
        }
      }
    }
  }
}
::v-deep .footer-container {
  margin-top: -50px;
}
.course-banner {
  display: block;
  width: 100%;
  height: 90px;
  margin: 20px 0 0;
  position: relative;
  z-index: 100;
}
</style>